import React from 'react'
import { Box, Stack } from '@mui/material'
import clsx from 'clsx'

import { Chip, TextField, Typography } from '~components/internal'
import type { PersonalizationVariable } from '~components/internal/VariableComponents'
import { spacing } from '~tokens/internal'

import './FallbackValuesSection.scss'

interface FallbackValuesSectionProps {
  variables: PersonalizationVariable[]
  fallbacks: Record<string, string>
  onFallbacksChange: (fallbacks: Record<string, string>) => void
  className?: string
}

const FallbackValuesSection: React.FC<FallbackValuesSectionProps> = ({
  variables,
  fallbacks,
  onFallbacksChange,
  className,
}) => {
  return (
    <Box className={clsx('fallback-values-section', className)}>
      <Typography variant='body2' className='fallback-values-section__title'>
        Fallback Values
      </Typography>
      <Typography
        variant='caption'
        color='textSecondary'
        className='fallback-values-section__description'
      >
        If a contact is missing this info, the fallback text will be used instead.
      </Typography>
      <Stack direction='column' sx={{ gap: spacing.compact }}>
        {variables.map((variable) => {
          return (
            <Stack
              key={variable.key}
              direction='row'
              sx={{
                alignItems: 'center',
                gap: spacing.compact,
              }}
            >
              <Chip label={variable.label} size='small' className='fallback-values-section__chip' />
              <div className='fallback-values-section__field'>
                <TextField
                  size='small'
                  placeholder={variable.label}
                  value={fallbacks[variable.key] ?? variable.label}
                  onChange={(e) =>
                    onFallbacksChange({ ...fallbacks, [variable.key]: e.target.value })
                  }
                  fullWidth
                />
              </div>
            </Stack>
          )
        })}
      </Stack>
    </Box>
  )
}

export default FallbackValuesSection
